import './word-art.css';

interface Props {
    fontSize?: string | number;
}

export const AppLogo = (props: Props) => {
    /*TODO - add classes by size that look good and a prop to define the size from an enum */
    return (
        <div className='word-art-container'>
            <h1 style={{fontSize: props.fontSize}}>Avron Quizzes!</h1>
        </div>
    );
};
